const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const classnames = require('classnames');

// @ commons
const { formatText } = require('core/i18n').i18n;
const OKModal = require('components/commons/OKModal/OKModal');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ constants
const { COMMONS } = require('constants/mortgageRequestHolderData');

const configText = config => {
    const text = {
        title: {
            delete: formatText('mortgageRequestMortgageEdit-confirmDeleteTitle'),
            other: formatText('mortgageRequestMortgageEdit-changeDataTitle')
        },
        body: {
            delete: `${formatText('mortgageRequestMortgageEdit-confirmDeleteP1')} ${formatText(
                'mortgageRequestMortgageEdit-confirmDeleteP2'
            )}`,
            messageSpecificText1: formatText('mortgageRequestMortgageEdit-messageSpecificText1'),
            messageSpecificText2: formatText('mortgageRequestMortgageEdit-messageSpecificText2', [COMMONS.MORTGAGE_CONFIRMATION_PHONE]),
            messageSpecificText3: formatText('mortgageRequestMortgageEdit-messageSpecificText3')
        },
        button: {
            delete: formatText('mortgageRequestMortgageEdit-confirmDeleteButtonDelete'),
            other: formatText('common-ok')
        }
    };
    return {
        title: text.title[config.title],
        body: text.body[config.body],
        button: text.button[config.button]
    };
};

const modal = ({ handlers, text, isDelete }) => {
    const optionText = configText(text);
    const lightBoxClass = classnames({
        'mortgage-request-target-date__warning': !isDelete,
        'mortgage-request-target-date__warning-delete': isDelete
    });
    let secondaryText = '';
    let onSecondaryClick = ()=>{};
    let messages = '';

    if (!isDelete) {
        messages = (
            <div>
                <p>
                    {formatText('mortgageRequestMortgageEdit-messageGeneralText')}
                </p>
            </div>
        );
    }

    if(text.title === 'delete') {
        secondaryText = 'common-cancel';
        onSecondaryClick = handlers.handleClose;
    }

    const content = (
        <div className={lightBoxClass}>
            <OKMessage type="important">
                {optionText.body}
            </OKMessage>
        </div>
    );

    return (
        <OKModal
            content={content}
            description={messages}
            footerType="navigation"
            isOpen={true}
            onCloseCallback={handlers.handleClose}
            onPrimaryButtonClick={handlers.handleClickBtn}
            onSecondaryButtonClick={onSecondaryClick}
            primaryButtonText={optionText.button}
            secondaryButtonText={secondaryText}
            title={optionText.title}
        />
    );
};

modal.propTypes = {
    handlers: PropTypes.object,
    text: PropTypes.object,
    isDelete: PropTypes.bool
};

module.exports = modal;
